define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl)=> {
    const fn = ($scope, $rootScope, $state, $stateParams, $q, ViewModelService, PolicyService, UserAccountService, DefaultProductProvider, $location)=> {
        const ctrl = Object.create(BaseCtrl);

        ctrl.init = ()=> {
            
            //console.log("IsValidZipCodeRequest: ",$rootScope.isValidZipCodeRequest);
            // Prevent this page from directly accessing with url
            // checking the $rootScope.accountDetails is undefined, which means 
            // user not clicked continue button in the AccountLookup screen
            // so redirect to account lookup screen
            // CHG0031104 - Commented if statement
            /*if ($rootScope.isValidZipCodeRequest){
                delete $rootScope["isValidZipCodeRequest"];
            }
            else{
                // account lookup screen
                //$state.go("nextSteps", {});
                $state.go("landingAccount", {});
            }*/

            const applicantDetails = {
                effectiveDate: new Date(),
                postalCode: '',
                account: undefined,
                productCode: undefined
            };
            $scope.view = ViewModelService.create(applicantDetails, 'pc',
                'edge.capabilities.policycommon.availability.dto.PostalCodeAvailabilityRequestDTO');

            $scope.activeSection = 'new';

            // populate only the selected zip pane
            function getZip(activeSection) {
                return ()=> {
                    return $scope.activeSection === activeSection ?
                        $scope.view.postalCode.value
                        : '';
                };
            }
            function setZip(val) {
                $scope.view.postalCode.value = val;
            }

            Object.defineProperties($scope, {
                'zipNew': {
                    get: getZip('new'),
                    set: setZip
                },
                'zipRetrieve': {
                    get: getZip('retrieve'),
                    set: setZip
                }
            });

            if ($stateParams.postalCode && $stateParams.quoteID) {
                $scope.view.postalCode.value = $stateParams.postalCode;
                $scope.quoteID = $stateParams.quoteID;
            }

            if ($stateParams.account) {
                const policySummariesPromise = PolicyService.getAccountPolicySummaries('policy');
                const accountSummaryPromise = UserAccountService.getAccountContactSummary();

                $q.when(accountSummaryPromise, (accountSummary) => {
                    $scope.view.value.account = accountSummary;
                    $scope.view.value.account.subtype = 'Person';
                    $scope.view.postalCode.value = accountSummary.primaryAddress.postalCode;
                });

                $q.when(policySummariesPromise, (policySummaries) => {
                    $scope.view.productCode.value = DefaultProductProvider.getDefaultProduct(policySummaries);
                });
            }
            //leadscloud test codes added -- Arpita
            $scope.hideGetQuoteForLeadcloud = false
            $scope.$watch('location.search()', ()=> {
                if($location.search().jobNum){
                    $scope.view.quoteID = {value:$location.search().jobNum}
                }
                if($location.search().zip){
                    $scope.zipRetrieve = $location.search().zip
                }
                if($location.search().jobNum && $location.search().zip){
                    $scope.hideGetQuoteForLeadcloud = true;
                    $scope.activeSection = 'retrieve'
                }
            }, true);

        };

        ctrl.activateNewQuote = ()=> {
            $scope.activeSection = 'new';
        };

        ctrl.activateRetrieveQuote = ()=> {
            $scope.activeSection = 'retrieve';
        };

        ctrl.goToRetrieveQuote = (form)=> {
            form.submitted = true;
            if (!$scope.view.postalCode.aspects.valid || !$scope.view.quoteID.value) {
                return;
            }
            
            // check if quote id is not filled or undefined
            // then display error message
            if ($scope.view.quoteID.value == ''
                    || $scope.view.quoteID.value == undefined){
                return;
            }
            
            $state.go('quoteentry', {
                quoteID: $scope.view.quoteID.value,
                postalCode: $scope.view.postalCode.value,
                shouldUpdateEffectiveDate: true
            }); //enter quote wizard
        };

        ctrl.goToNewQuote = (form)=> {
            
            // check account details is undefined
            // CHG0031104 - Uncommented if statement
            if ($rootScope.accountDetails == undefined){
                $rootScope.accountDetails = {
                    accountHolder : {
                        accountExists: false
                    }
                };
            }
            
            form.submitted = true;
            if (!$scope.view.aspects.subtreeValid) {
                return;
            }
            $state.go('quoteentry', $scope.view.value); //enter quote wizard
        };

        return ctrl.create($scope);
    };

    fn.$inject = [
        '$scope',
        '$rootScope',
        '$state',        
        '$stateParams',
        '$q',
        'ViewModelService',
        'qnb.PolicyService',
        'qnb.UserAccountService',
        'qnb.DefaultProductProvider',
        '$location'
    ];

    return fn;
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/controllers/ZipCodeCtrl.js
 **/